// extracted by mini-css-extract-plugin
export var boxItems = "_18-1";
export var button = "_18-5";
export var filterGroupBox = "_18-0";
export var icon = "_18-2";
export var iconSecondary = "_18-4";
export var iconWrapper = "_18-3";